import { render, staticRenderFns } from "./designerSignup.vue?vue&type=template&id=5e397253&scoped=true&"
import script from "./designerSignup.vue?vue&type=script&lang=js&"
export * from "./designerSignup.vue?vue&type=script&lang=js&"
import style0 from "./designerSignup.vue?vue&type=style&index=0&id=5e397253&lang=less&scoped=true&"
import style1 from "./designerSignup.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e397253",
  null
  
)

export default component.exports